'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'comet';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e003';
var svgPathData = ['M32 309.8c0 93.6 75.9 170.2 169.3 170.2 54.4 0 105.4-26.1 137.2-70.2l134.2-185.8-50.6 0c-5.4 0-10.4-2.7-13.4-7.3s-3.4-10.2-1.2-15.2L479.7 37.4c.2-.5 .3-1 .3-1.5 0-2.1-1.7-3.8-3.8-3.8-.5 0-1.1 .1-1.5 .3L310.4 104.6c-4.9 2.2-10.7 1.7-15.2-1.2s-7.3-8-7.3-13.4L288 32 100.3 172.8C57.3 205 32 256 32 309.8zm54.3-37.4c1.9-5.8 6.9-10 12.9-10.9l65.3-9.5 29.2-59.2c2.7-5.5 8.3-8.9 14.3-8.9s11.7 3.5 14.3 8.9l29.2 59.2 65.3 9.5c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4l-47.2 46 11.2 65c1 6-1.4 12.1-6.4 15.7s-11.5 4.1-16.8 1.2l-58.4-30.7-58.4 30.7c-5.4 2.8-11.9 2.4-16.8-1.2s-7.4-9.6-6.4-15.7l11.2-65-47.2-46c-4.4-4.3-5.9-10.6-4-16.4z', 'M320 32c0-26.4-30.1-41.4-51.2-25.6L81.1 147.2C30 185.5 0 246.1 0 309.8 0 420.9 90 512 201.3 512 265.9 512 326.6 481 364.4 428.6L498.6 242.7c15.3-21.2 .2-50.7-25.9-50.7L446.6 192 509 50.3c2-4.5 3-9.5 3-14.4 0-19.8-16-35.8-35.8-35.8-5 0-9.9 1-14.4 3L320 65.4 320 32zm154.6 .3c.5-.2 1-.3 1.5-.3 2.1 0 3.8 1.7 3.8 3.8 0 .5-.1 1.1-.3 1.5L407.4 201.6c-2.2 4.9-1.7 10.7 1.2 15.2s8 7.3 13.4 7.3l50.6 0-134.2 185.8C306.7 453.9 255.6 480 201.3 480 107.9 480 32 403.4 32 309.8 32 256 57.3 205 100.3 172.8L288 32 288 89.9c0 5.4 2.7 10.4 7.3 13.4s10.2 3.4 15.2 1.2L474.6 32.3zM169.1 283.7c10.4-1.5 19.4-8.1 24.1-17.5l14.8-30.1 14.8 30.1c4.7 9.4 13.7 16 24.1 17.5l33.2 4.8-24 23.4c-7.5 7.4-11 17.9-9.2 28.3l5.7 33.1-29.7-15.6c-9.3-4.9-20.5-4.9-29.8 0l-29.7 15.6 5.7-33.1c1.8-10.4-1.7-21-9.2-28.3l-24-23.4 33.2-4.8zm53.3-90.8c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2l58.4-30.7 58.4 30.7c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;